__turbopack_context__.v({
  "appDownloadBadge": "YtP2DG_appDownloadBadge",
  "appDownloadBadgeBody": "YtP2DG_appDownloadBadgeBody",
  "appDownloadBadgeText": "YtP2DG_appDownloadBadgeText",
  "appDownloadBadgeTitle": "YtP2DG_appDownloadBadgeTitle",
  "reviewsText": "YtP2DG_reviewsText",
  "reviewsWrapper": "YtP2DG_reviewsWrapper",
});
